"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeepMemoKey = exports.useDeepMemo = void 0;
var react_1 = require("react");
var equality_1 = require("@wry/equality");
function useDeepMemo(memoFn, key) {
    var ref = react_1.useRef();
    if (!ref.current || !equality_1.equal(key, ref.current.key)) {
        ref.current = { key: key, value: memoFn() };
    }
    return ref.current.value;
}
exports.useDeepMemo = useDeepMemo;
function useDeepMemoKey(key) {
    var ref = react_1.useRef();
    if (!ref.current || !equality_1.equal(key, ref.current)) {
        ref.current = key;
    }
    return ref.current;
}
exports.useDeepMemoKey = useDeepMemoKey;
//# sourceMappingURL=useDeepMemo.js.map